import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const submitFundingRequestToFunder = createApiThunk<void, { id: string; hasBeenSubmitted: boolean }>(
  "fundingRequests/submitFundingRequestToFunder",
  async ({ id, hasBeenSubmitted }, { extra: { adminRepository } }) => {
    return adminRepository!.submitToFunder(id, { hasBeenSubmitted });
  },
);

export const resetSubmitFundingRequestToFunder = createAction("fundingRequests/resetSubmitFundingRequestToFunder");
